import * as React from "react";
import { useForm } from "react-hook-form";
import { AppStepper } from "../../components/UI/AppStepper/AppStepper";

export function TestPage(): JSX.Element {
  useForm<Record<string, any>>({
    mode: "onBlur",
    defaultValues: {
      company: "ABC",
    },
  });
  const [activeStep] = React.useState(1);
  return (
    <>
      <AppStepper
        connector={<></>}
        activeStep={activeStep}
        allSteps={[
          {
            label: (
              <>
                <div className="flex flex-row">
                  <p>Hii</p>
                  <span>HEllo</span>
                </div>
                <div></div>
              </>
            ),
          },
        ]}
      />
      {activeStep > 0 && <p>HELLO</p>}
    </>
  );
}
